import React, { useEffect, useState } from 'react';
export function Hero() {
  const [particles, setParticles] = useState<{
    id: number;
    top: string;
    left: string;
    size: string;
    duration: string;
    delay: string;
  }[]>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 80
    }).map((_, i) => ({
      id: i,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      size: `${Math.random() * 1 + 1}px`,
      duration: `${Math.random() * 6 + 6}s`,
      delay: `${Math.random() * 5}s`
    }));
    setParticles(newParticles);
  }, []);
  return <section className="relative w-full h-screen min-h-[700px] overflow-hidden bg-brand-dark flex items-center" data-id="element-119">
      {/* Background Gradients */}
      <div className="absolute top-0 right-0 w-[60%] h-[60%] bg-[radial-gradient(ellipse_at_center,_rgba(123,92,232,0.2)_0%,_transparent_70%)] pointer-events-none" data-id="element-120" />
      <div className="absolute bottom-0 left-0 w-[40%] h-[40%] bg-[radial-gradient(ellipse_at_center,_rgba(201,169,110,0.1)_0%,_transparent_70%)] pointer-events-none" data-id="element-121" />

      {/* Decorative Circles */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-122">
        <div className="w-[500px] h-[500px] rounded-full border border-brand-gold/10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-123" />
        <div className="w-[400px] h-[400px] rounded-full border border-brand-violet/10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-124" />
      </div>

      {/* Particles */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-125">
        {particles.map(p => <div key={p.id} className="particle" style={{
        top: p.top,
        left: p.left,
        width: p.size,
        height: p.size,
        animationDuration: p.duration,
        animationDelay: p.delay
      }} data-id="element-126" />)}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 w-full" data-id="element-127">
        <div className="max-w-[600px] animate-fade-up" data-id="element-128">
          <div className="inline-flex items-center bg-brand-gold/15 border border-brand-gold/30 text-brand-gold text-[11px] tracking-[0.1em] uppercase rounded-[40px] py-[6px] px-[18px] mb-[28px]" data-id="element-129">
            ✦ EDICIÓN MAESTRO: TRANSMUTACIÓN DEL INCONSCIENTE
          </div>

          <h1 className="font-display italic text-[clamp(42px,7vw,82px)] font-light leading-[1.05] text-brand-cream mb-5" data-id="element-130">
            No atraes lo que quieres.
            <br data-id="element-131" />
            Atraes lo que <span className="text-brand-gold" data-id="element-132">eres</span>.
          </h1>

          <p className="font-body font-light text-[17px] leading-[1.75] text-brand-cream/65 max-w-[480px] mb-10" data-id="element-133">
            Si has intentado terapia, afirmaciones y libros de autoayuda y
            sigues atascado en los mismos patrones... el problema no es tu
            esfuerzo. Es que nunca trabajaste a nivel subatómico.
          </p>

          <a href="#producto" className="inline-block bg-brand-gold text-brand-dark font-body text-[15px] font-medium py-4 px-9 rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_8px_28px_rgba(201,169,110,0.3)]" data-id="element-134">
            Quiero RENACER ahora — $6.39 &rarr;
          </a>

          <p className="font-body text-[13px] text-brand-cream/40 mt-3" data-id="element-135">
            Precio de lanzamiento &middot; Descarga inmediata &middot; Antes $47
          </p>

          <div className="flex flex-row flex-wrap gap-6 mt-12" data-id="element-136">
            {['Acceso instantáneo', 'Pago seguro', 'Garantía 7 días'].map((badge, i) => <div key={i} className="flex items-center gap-2 font-body text-[13px] text-brand-cream/50" data-id="element-137">
                  <div className="w-[5px] h-[5px] rounded-full bg-brand-gold" data-id="element-138" />
                  {badge}
                </div>)}
          </div>
        </div>
      </div>
    </section>;
}